export function openCalendarBoardInNewWindow(): void {
    window.open('/calendar/view/board', '_blank');
}
